// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2lUd3","slide":"slide-rX0uJ","item":"item-1TFiv day-3UEdI","item__head":"item__head-2xEmA date-24_Tz","item__middle":"item__middle-KHdCV date__dow-I-iac"};